import { render, staticRenderFns } from "./UserDetailContainer.vue?vue&type=template&id=ce33ad0e&scoped=true&"
import script from "./UserDetailContainer.vue?vue&type=script&lang=js&"
export * from "./UserDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserDetailContainer.vue?vue&type=style&index=1&id=ce33ad0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce33ad0e",
  null
  
)

export default component.exports